<template>
  <div v-if="isShow" class="fix-center">
    <div class="fix-box center-center dialog_boss" :style="{ width: width + 'px', height: height + 'px' }">
      <div class="fix-title">
        <slot name="title"></slot>
        <i v-if="!hideClose" class="el-icon-close" @click="hide"></i>
      </div>
      <div :class="['fix-center-main', noBtm ? 'no-btm' : '']">
        <slot name="main"></slot>
      </div>
      <div v-if="!noBtm" class="fix-btm">
        <slot name="btm"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'fix-center',
  props: ['w', 'h', 'noBtm', 'hideClose'],
  data() {
    return {
      isShow: false
    }
  },
  computed: {
    height() {
      return this.h
    },
    width() {
      return this.w
    }
  },
  methods: {
    show() {
      !this.isShow && (this.isShow = true)
    },
    hide() {
      if (this.isShow) {
        this.isShow = false
        this.$emit('close')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.fix-center {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 2010;

  .fix-box {
    width: 90%;
    height: 90%;
    border-radius: 5px;
  }

  .fix-title {
    font-size: 18px;
    text-align: center;
    padding: 0 15px;
    height: 50px;
    line-height: 50px;
    border-bottom: 1px solid #e9e9e9;
    font-weight: 550;

    i {
      float: right;
      font-weight: 500;
      margin-top: 15px;
      cursor: pointer;
    }
  }

  .fix-center-main {
    overflow: auto;
    padding: 20px;
    height: calc(100% - 110px);

    &.no-btm {
      height: calc(100% - 50px);
    }
  }

  .fix-btm {
    height: 60px;
    border-top: 1px solid #e9e9e9;
    text-align: center;
  }
}</style>
